/* ============================================================
   BloomUp — tier discount codes (AUTO-APPLY DISABLED)

   The tier bar promises 10/15/20% off via discount codes
   (bloomup10 / bloomup15 / bloomup20). This script previously
   auto-applied the best eligible code as the cart crossed each
   threshold.

   AUTO-APPLY IS NOW OFF by decision (Aug 2026): no coupon is
   placed on the cart unless the customer explicitly selects one —
   via the Available Offers popup (Apply button) or by typing a
   code into the coupon box. Both of those flows live in
   assets/bloomup-coupon.js and are unaffected.

   To re-enable auto-apply, set AUTO_APPLY to true below. The full
   original tier logic is preserved and gated behind that flag.

   MUST MATCH SHOPIFY. If a code's minimum changes in admin, change
   it here and in snippets/bloomup-tiers.liquid too.
   ============================================================ */
(function () {
  "use strict";

  var AUTO_APPLY = false; /* <-- flip to true to restore auto-apply */

  var MANUAL_KEY = "bu-coupon-manual";

  /* highest threshold first — the first match wins */
  var TIERS = [
    { min: 499900, code: "bloomup20" },
    { min: 249900, code: "bloomup15" },
    { min: 149900, code: "bloomup10" }
  ];

  if (!AUTO_APPLY) return; /* auto-apply disabled — do nothing */

  var OURS = {};
  TIERS.forEach(function (t) { OURS[t.code] = true; });

  var busy = false;
  var lastAttempt = "";
  var timer = null;

  function manualOverride() {
    try { return window.sessionStorage.getItem(MANUAL_KEY) === "1"; }
    catch (e) { return false; }
  }

  function bestFor(subtotal) {
    for (var i = 0; i < TIERS.length; i++) {
      if (subtotal >= TIERS[i].min) return TIERS[i].code;
    }
    return null;
  }

  /* the discount code currently on the cart, lowercased, or null */
  function appliedCode(cart) {
    var apps = (cart && cart.cart_level_discount_applications) || [];
    for (var i = 0; i < apps.length; i++) {
      var title = apps[i] && apps[i].title;
      if (title) return String(title).toLowerCase();
    }
    return null;
  }

  function sync() {
    if (busy || manualOverride()) return;
    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;

        var subtotal =
          cart.items_subtotal_price != null
            ? cart.items_subtotal_price
            : (cart.original_total_price != null ? cart.original_total_price : cart.total_price);

        var want = bestFor(subtotal);
        var have = appliedCode(cart);

        /* a code the customer chose themselves — do not touch it */
        if (have && !OURS[have]) return;

        if (!want) return;          /* below every tier */
        if (have === want) return;  /* already correct */

        /* do not retry the same code at the same subtotal in a loop */
        var key = want + ":" + subtotal;
        if (key === lastAttempt) return;
        lastAttempt = key;

        busy = true;
        fetch("/discount/" + encodeURIComponent(want) + "?redirect=/cart.js", {
          credentials: "same-origin"
        })
          .then(function () {
            busy = false;
            if (window.BUCart && window.BUCart.rerender) window.BUCart.rerender();
          })
          .catch(function () { busy = false; });
      })
      .catch(function () {});
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  function init() {
    sync();

    /* re-check whenever the cart drawer changes */
    var host = document.querySelector("hdt-cart-drawer");
    if (host && window.MutationObserver) {
      new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    }

    /* and after any add to cart from anywhere on the page */
    if (window.fetch) {
      var orig = window.fetch;
      window.fetch = function (input, initOpts) {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var p = orig.apply(this, arguments);
        if (/\/cart\/(add|change|update)(\.js)?/.test(String(url))) {
          p.then(function () { schedule(); }).catch(function () {});
        }
        return p;
      };
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();